import { Injectable, EventEmitter } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { VERSION, BUILD_DATE } from '../../../environments/version';

@Injectable()
export class SettingsService {

    public layoutSettingsChange = new EventEmitter<{key: string, value: any}>();
    private user: any;
    private app: any;
    private layout: any;
    public settings: any;

  constructor(private http: HttpClient) {

        // App Settings
        // -----------------------------------
        this.app = {
            name: 'Chat Starter & ChatAI Admin',
            description: 'Portal',
            year: ((new Date()).getFullYear()),
            version: VERSION,  // Auto-generated from package.json during build
            buildDate: BUILD_DATE  // Auto-generated build date and time
      };

      this.settings = {};

      const jsonFile = '/settings';

      const promise = this.http.get(jsonFile).toPromise();

    promise.then(cfg => {
        this.settings = cfg;
      });

      // User Settings
      // -----------------------------------
      this.user = {
        name: 'John',
        job: 'ng-developer',
        picture: 'assets/img/user/02.jpg'
      };

        // Layout Settings
        // -----------------------------------
        this.layout = {
            isFixed: true,
            isCollapsed: false,
            isBoxed: false,
            isRTL: false,
            horizontal: false,
            isFloat: false,
            asideHover: false,
            theme: null,
            asideScrollbar: false,
            isCollapsedText: false,
            useFullLayout: false,
            hiddenFooter: false,
            nodeSidebarOpen: false,
            linkSidebarOpen: false,
            offsidebarOpen: false,
            rightPanelOpen: false,
            asideToggled: false,
            viewAnimation: 'ng-fadeInUp'
        };

  }

  getSetting(name) {
    return name ? this.settings[name] : this.settings;
  }

    getAppSetting(name) {
        return name ? this.app[name] : this.app;
    }
    getUserSetting(name) {
        return name ? this.user[name] : this.user;
    }
    getLayoutSetting(name) {
        return name ? this.layout[name] : this.layout;
    }

    setAppSetting(name, value) {
        if (typeof this.app[name] !== 'undefined') {
            this.app[name] = value;
        }
    }
    setUserSetting(name, value) {
        if (typeof this.user[name] !== 'undefined') {
            this.user[name] = value;
        }
    }
    setLayoutSetting(name, value) {
        if (typeof this.layout[name] !== 'undefined') {
            if (this.layout[name] !== value) {
                this.layout[name] = value;
                this.layoutSettingsChange.emit({key: name, value: value});
            }
            return this.layout[name];
        }
    }

    toggleLayoutSetting(name) {
        return this.setLayoutSetting(name, !this.getLayoutSetting(name));
    }

}
